import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sm:col-span-full"
}
const _hoisted_2 = {
  key: 0,
  class: "preview-modal pb-2"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  role: "list",
  class: "divide-y divide-gray-200 rounded-md border border-gray-200"
}
const _hoisted_7 = { class: "flex w-0 flex-1 items-center" }
const _hoisted_8 = { class: "ml-2 w-0 flex-1 truncate" }
const _hoisted_9 = {
  key: 0,
  class: "ml-4 flex-shrink-0"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "ml-4 flex-shrink-0" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "space-y-1 text-center" }
const _hoisted_16 = { class: "flex text-sm text-gray-600" }
const _hoisted_17 = {
  for: "file-upload",
  class: "relative"
}
const _hoisted_18 = { class: "cursor-pointer rounded-md font-medium text-blue-1 focus-within:outline-none hover:text-blue-2 inline-block" }
const _hoisted_19 = ["id"]
const _hoisted_20 = {
  key: 1,
  class: "mt-2 text-sm text-gray-900"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["for"]
const _hoisted_23 = ["id"]
const _hoisted_24 = { class: "space-y-1 text-center" }
const _hoisted_25 = { class: "flex text-sm text-gray-600" }
const _hoisted_26 = {
  for: "file-upload",
  class: "relative"
}
const _hoisted_27 = ["id"]
const _hoisted_28 = { class: "relative z-50" }
const _hoisted_29 = ["id"]
const _hoisted_30 = ["id"]
const _hoisted_31 = ["href"]
const _hoisted_32 = ["onClick"]

import { shallowRef, ref, onMounted, computed } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { AttachmentRequest, DynamicProperty } from "@/models/dtos";
import { useRoute } from "vue-router";
import { TYPES } from "@/types";
import { useStore } from "vuex";
import { MainContainer } from "@/models/MainContainer";
import { Profile } from "@/models/Profile";

export default /*@__PURE__*/_defineComponent({
  __name: 'InputFile',
  props: {
  model: {
    required: false,
  },
  type: String,
  positionId: Number,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  admin: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const containerByDNS = ref<Profile>(null);

const emit = __emit;
const props = __props;

const route = useRoute();
const files = ref([]);
const fileInput = ref(null);
const showingErrorMessage = ref(false);
let model = shallowRef(props.model as DynamicProperty);

const showErrorMessage = () => {
  showingErrorMessage.value = true;
};

const hideErrorMessage = () => {
  showingErrorMessage.value = false;
};

const handleFileDrop = (event: any) => {
  event.preventDefault();
  const newFiles = [] as AttachmentRequest[];

  event.dataTransfer.files.forEach((element: any) => {
    // validate file size
    if (element.size > 5000000) {
      alert("Filen är för stor");
      return;
    }

    const file = new AttachmentRequest();
    file.filename = element.name;
    const reader = new FileReader();
    reader.onload = (fileEvent) => {
      file.data = fileEvent.target.result.toString();
    };
    reader.readAsDataURL(element);
    newFiles.push(file);
  });

  files.value = [...files.value, ...newFiles];

  model.value.data = files;
  emit("change", model.value);
};

const handleFileUpload = () => {
  const newFiles = [] as AttachmentRequest[];

  fileInput.value.files.forEach((element: any) => {
    // validate file size
    if (element.size > 5000000) {
      alert("Filen är för stor");
      return;
    }

    const file = new AttachmentRequest();
    file.filename = element.name;
    const reader = new FileReader();
    reader.onload = (fileEvent) => {
      file.data = fileEvent.target.result.toString();
    };
    reader.readAsDataURL(element);
    newFiles.push(file);
  });

  files.value = [...files.value, ...newFiles];

  model.value.data = files;
  emit("change", model.value);
};

const handleFileRemove = (file: any) => {
  files.value.splice(files.value.indexOf(file), 1);

  model.value.data = files;
  emit("change", model.value);
};
onMounted(() => {
  if (model.value.data) {
    files.value = model.value.data;
  }
});

function getUrl(file: any) {
  const url =
    TYPES.BaseURL +
    "/api/dispatcher/storage/application/" +
    route.params.applicantId +
    "/files/" +
    file.url;
  return url;
}

onMounted(async () => {
  await store.dispatch("loadContainerTheme");
  try {
    await store.dispatch("loadContainerTheme");
    containerByDNS.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
    // isLoaded.value = true;
  } catch (error) {
    console.error("Error loading public container:", error);
  }
});

const isPreviewModalVisible = ref(false);
const previewFileUrl = ref('');
const currentPreviewFile = ref(null);

const openPreviewModal = (file: any, event: Event) => {
  event.preventDefault();

  currentPreviewFile.value = file;

  if (isImageFile(file)) {
    previewFileUrl.value = getUrl(file);
    isPreviewModalVisible.value = true;
  } else if (isPdfFile(file)) {
  previewFileUrl.value = getUrl(file);
  isPreviewModalVisible.value = true;
  } else {
    // Om varken bild eller PDF, kanske det är ett Word-dokument
    const wordPreviewUrl = getWordPreviewUrl(file);
    previewFileUrl.value = wordPreviewUrl;
    isPreviewModalVisible.value = true;
  }
};

const closePreviewModal = () => {
  isPreviewModalVisible.value = false;
};

const isImageFile = (file: any) => {
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp']; // Lägg till fler bildtyper om det behövs
  const extension = file.filename.split('.').pop().toLowerCase();
  return imageExtensions.includes(extension);
};

// const isPdfFile = (file: any) => {
//   const pdfExtensions = ['pdf']; // Lägg till fler PDF-typer om det behövs
//   const extension = file.filename.split('.').pop().toLowerCase();
//   return pdfExtensions.includes(extension);
// };
const isPdfFile = (file: any) => {
  // Kontrollera om filens MIME-typ är PDF
  return file.type === 'application/pdf';
};


const getWordPreviewUrl = (file: any) => {
  return `https://docs.google.com/viewer?url=${encodeURIComponent(getUrl(file))}&embedded=true`;
}

const themedText = computed(() => store.getters.getContainerThemedText);

return (_ctx: any,_cache: any) => {
  return (__props.adminView)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[8] || (_cache[8] = _createElementVNode("dt", { class: "text-sm font-medium text-gray-500" }, "Bifogade dokument", -1)),
        (isPreviewModalVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("div", { class: "flex flex-row-reverse" }, [
                  _createElementVNode("button", {
                    class: "text-xl",
                    onClick: closePreviewModal
                  }, "×")
                ]),
                (isImageFile(currentPreviewFile.value))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: previewFileUrl.value,
                      alt: "Preview",
                      style: {"width":"100%","height":"auto"}
                    }, null, 8, _hoisted_3))
                  : (isPdfFile(currentPreviewFile.value))
                    ? (_openBlock(), _createElementBlock("iframe", {
                        key: 1,
                        src: 'https://mozilla.github.io/pdf.js/web/viewer.html?file=' + encodeURIComponent(previewFileUrl.value),
                        width: "100%",
                        height: "600px"
                      }, null, 8, _hoisted_4))
                    : (_openBlock(), _createElementBlock("iframe", {
                        key: 2,
                        src: previewFileUrl.value,
                        width: "100%",
                        height: "600px"
                      }, null, 8, _hoisted_5))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("dd", {
          style: _normalizeStyle({color: themedText.value?.otherText}),
          class: "mt-1 text-sm text-gray-900"
        }, [
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (attachment) => {
              return (_openBlock(), _createElementBlock("li", {
                key: attachment.id,
                class: "flex items-center justify-between py-3 pl-3 pr-4 text-sm"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[2] || (_cache[2] = _createElementVNode("i", {
                    class: "fas fa-paperclip mr-2 flex-shrink-0 items-center text-gray-400",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(attachment.filename), 1)
                ]),
                (__props.editMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (handleFileRemove(attachment)),
                        class: "font-medium text-red-600 hover:text-red-500"
                      }, " Radera ", 8, _hoisted_10)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(event => openPreviewModal(attachment, event), ["prevent"]),
                    class: "font-medium text-orange-1 hover:text-orange-3 mr-3"
                  }, _cache[3] || (_cache[3] = [
                    _createElementVNode("i", { class: "fa-solid fa-magnifying-glass" }, null, -1)
                  ]), 8, _hoisted_12),
                  _createElementVNode("a", {
                    href: getUrl(attachment),
                    download: "",
                    class: "font-medium text-blue-1 hover:text-blue-3"
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "fa-solid fa-file-arrow-down" }, null, -1)
                  ]), 8, _hoisted_13)
                ])
              ]))
            }), 128))
          ]),
          (__props.editMode)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["relative mt-4 flex justify-center rounded-md border-2 border-dashed border-gray-300 px-6 pt-5 pb-6", {
          'bg-gray-100 text-darkGray-2 cursor-not-allowed pointer-events-none':
            __props.disabled,
        }]),
                id: _unref(model).key,
                onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                onDrop: handleFileDrop
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(files.value.length > 0
                    ? "Ladda upp ytterligare fil(er)"
                    : "Ladda upp fil(er)"), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "pl-1 inline-block" }, "eller dra och släpp", -1)),
                      _createElementVNode("input", {
                        id: "file-upload",
                        name: "file-upload",
                        type: "file",
                        class: _normalizeClass(["sr-only", {
                  'bg-gray-100 text-darkGray-2 cursor-not-allowed pointer-events-none':
                    __props.disabled,
                }]),
                        ref_key: "fileInput",
                        ref: fileInput,
                        onChange: handleFileUpload
                      }, null, 34)
                    ])
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "filstorlek max 5MB", -1))
                ]),
                _createElementVNode("div", {
                  id: 'icon-error_' + _unref(model).key,
                  class: "hidden absolute top-0 bottom-0 right-0 left-auto w-[60px] flex flex-row justify-center items-center",
                  onMouseenter: showErrorMessage,
                  onMouseleave: hideErrorMessage
                }, _cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "text-red-2 fa-solid fa-circle-info" }, null, -1)
                ]), 40, _hoisted_19)
              ], 42, _hoisted_14))
            : _createCommentVNode("", true)
        ], 4),
        (files.value.length === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Inga bifogade filer."))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
        _createElementVNode("span", {
          style: _normalizeStyle({color: themedText.value?.otherText}),
          class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1",
          for: _unref(model).key
        }, _toDisplayString(_unref(model).label), 13, _hoisted_22),
        (!__props.admin)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["relative mt-1 flex justify-center rounded-md border-2 border-dashed border-gray-300 px-6 pt-5 pb-6", {
        'bg-gray-100 text-darkGray-2 cursor-not-allowed pointer-events-none':
          __props.disabled,
      }]),
              id: _unref(model).key,
              onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
              onDrop: handleFileDrop
            }, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({color: themedText.value?.workAtText}),
                      class: "cursor-pointer rounded-md font-medium text-blue-1 focus-within:outline-none hover:text-blue-2 inline-block"
                    }, _toDisplayString(files.value.length > 0
                  ? "Ladda upp ytterligare fil(er)"
                  : "Ladda upp fil(er)"), 5),
                    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "pl-1 inline-block" }, "eller dra och släpp", -1)),
                    _createElementVNode("input", {
                      id: "file-upload",
                      name: "file-upload",
                      type: "file",
                      class: _normalizeClass(["sr-only", {
                'bg-gray-100 text-darkGray-2 cursor-not-allowed pointer-events-none':
                  __props.disabled,
              }]),
                      ref_key: "fileInput",
                      ref: fileInput,
                      onChange: handleFileUpload
                    }, null, 34)
                  ])
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "filstorlek max 5MB", -1))
              ]),
              _createElementVNode("div", {
                id: 'icon-error_' + _unref(model).key,
                class: "hidden absolute top-0 bottom-0 right-0 left-auto w-[60px] flex flex-row justify-center items-center",
                onMouseenter: showErrorMessage,
                onMouseleave: hideErrorMessage
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "text-red-2 fa-solid fa-circle-info" }, null, -1)
              ]), 40, _hoisted_27)
            ], 42, _hoisted_23))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", {
            class: "absolute top-0 left-0 right-0 bottom-auto bg-white rounded-md p-2 shadow-md",
            id: 'outer-error_' + _unref(model).key
          }, [
            _createElementVNode("p", {
              class: "font-medium text-sm text-red-2",
              id: 'error_' + _unref(model).key
            }, null, 8, _hoisted_30)
          ], 8, _hoisted_29)
        ], 512), [
          [_vShow, showingErrorMessage.value]
        ]),
        (files.value.length > 0)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 1,
              class: _normalizeClass({
        'flex flex-col gap-1 text-sm font-medium bg-blue-4 p-4 rounded leading-tight mt-2':
          !__props.disabled,
        'flex flex-col gap-1 text-sm font-medium bg-gray-2 p-4 rounded leading-tight mt-2':
          __props.disabled,
      })
            }, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-darkGray-1 font-semibold mb-1" }, "Bifogade filer:", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: file.filename,
                  class: "flex gap-2 items-center"
                }, [
                  _createElementVNode("a", {
                    href: getUrl(file)
                  }, _toDisplayString(file.filename), 9, _hoisted_31),
                  (!__props.disabled)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (handleFileRemove(file)),
                        class: "flex gap-1 items-center text-red-2 hover:text-red-1"
                      }, _cache[12] || (_cache[12] = [
                        _createElementVNode("i", { class: "fa-solid fa-trash text-xs" }, null, -1)
                      ]), 8, _hoisted_32))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ]))
}
}

})